import React from 'react';
import { WeatherProvider } from './context';
import { AuthProvider } from './context/AuthContext';
import { MainLayout } from './components/layout/MainLayout';
import { AuthGate } from './components/auth/AuthGate';
import './styles/theme.css';

console.log('App rendering');

export default function App() {
  return (
    <AuthProvider>
      <WeatherProvider>
        <AuthGate>
          <MainLayout />
        </AuthGate>
      </WeatherProvider>
    </AuthProvider>
  );
}